import React, { Component } from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Heading, Map } from '../../components';

import css from './ListingPage.module.css';
import { offsetByMiles } from '../../util/uiHelpers';



class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    // Render the interactive Mapbox map (with + / − zoom controls) directly,
    // instead of a static preview that only activates on click.
    this.state = { isStatic: false };
  }

  render() {
    const {
      className,
      rootClassName,
      geolocation,
      publicData,
      listingId,
      mapsConfig,
    } = this.props;

    if (!geolocation) {
      return null;
    }

    const address =
      publicData && publicData.location ? publicData.location.address : '';
    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId
      ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}`
      : null;

    // 🗺️ Shift the location by 1 mile
    const shiftedLocation = offsetByMiles(geolocation.lat, geolocation.lng, 1);

    const mapProps = mapsConfig.fuzzy.enabled
      ? {
        obfuscatedCenter: obfuscatedCoordinates(
          shiftedLocation,
          mapsConfig.fuzzy.offset,
          cacheKey
        ),
      }
      : { address, center: shiftedLocation }; // use shifted center instead of real location

    const map = <Map {...mapProps} useStaticMap={this.state.isStatic} />;

    return (
      <section className={classes} id="listing-location">
        <div className={css.headingNdescription}>
          <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
            <FormattedMessage id="ListingPage.locationTitle" />
          </Heading>
          <p>
            Exact address will be shared with guest family once booking has been
            confirmed.
          </p>
        </div>
        {this.state.isStatic ? (
          <button
            className={css.map}
            onClick={() => {
              this.setState({ isStatic: false });
            }}
          >
            {map}
          </button>
        ) : (
          <div className={css.map}>{map}</div>
        )}
      </section>
    );
  }
}

SectionMapMaybe.defaultProps = {
  rootClassName: null,
  className: null,
  geolocation: null,
  listingId: null,
};

SectionMapMaybe.propTypes = {
  rootClassName: string,
  className: string,
  geolocation: propTypes.latlng,
  listingId: propTypes.uuid,
};

export default SectionMapMaybe;
